import { apiGateway } from "@/shared/apiGateway";

const getDashboard = (context, { contractorRegionId }) => {
  var url = "api/dashboard/";
  if (contractorRegionId !== "0") {
    url = url + "?contractorRegionId=" + contractorRegionId;
  }
  return apiGateway
    .apiGatewayGET(url)
    .then(data => {
      context.commit(
        "REPORT_SETPLANTWITHOUTSTATINSPCHARTDATA",
        data.dashboardCharts.plantWithoutStatInsp
      );
      context.commit(
        "REPORT_SETTIMEDDEFECTSTATUSESCHARTDATA",
        data.dashboardCharts.timedDefectStatus
      );
      context.commit(
        "REPORT_SETUNTIMEDDEFECTSTATUSESCHARTDATA",
        data.dashboardCharts.untimedDefectStatus
      );
      context.commit(
        "REPORT_SETSAFEDSTATUSESCHARTDATA",
        data.dashboardCharts.safedStatus
      );
      context.commit(
        "REPORT_SETSTATINSPSTATUSESCHARTDATA",
        data.dashboardCharts.statInspStatus
      );
      context.commit("set_quote_metric", data.metrics.quoteMetric);
    })
    .catch(error => {
      console.error(error);
      context.dispatch("SHOW_ERROR_ALERT", ["Error getting Dashboard"], {
        root: true
      });
    });
};

export default {
  getDashboard
};
